import { render, staticRenderFns } from "./FixedVsFloatingRates.vue?vue&type=template&id=92dcabb4&scoped=true"
import script from "./FixedVsFloatingRates.vue?vue&type=script&lang=js"
export * from "./FixedVsFloatingRates.vue?vue&type=script&lang=js"
import style0 from "./FixedVsFloatingRates.vue?vue&type=style&index=0&id=92dcabb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dcabb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
